import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Box, Container, Grid, Tabs, Tab, Badge } from '@mui/material';
import ParentForm from '../components/forms/ParentForm';
import ChildrenForm from '../components/forms/ChildrenForm';
import ToDoTab from '../components/profiles/ToDoTab';

const ProfilePage: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const tabParam = searchParams.get('tab');
  const initialTab = tabParam !== null ? Math.max(0, Math.min(1, parseInt(tabParam, 10) || 0)) : 0;
  const [tabValue, setTabValue] = useState(initialTab);
  const [todoCount, setTodoCount] = useState<number | null>(null);

  useEffect(() => {
    const t = tabParam !== null ? Math.max(0, Math.min(1, parseInt(tabParam, 10) || 0)) : 0;
    setTabValue(t);
  }, [tabParam]);

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
    setSearchParams({ tab: String(newValue) }, { replace: true });
  };

  return (
    <div className="event-page p-5 mb-20">
      <Container maxWidth="lg">
        <Box sx={{ py: 4 }}>
          {/* Tab Navigation */}
          <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
            <Tabs value={tabValue} onChange={handleTabChange}>
              <Tab label="Profile" />
              <Tab
                label={
                  todoCount && todoCount > 0 ? (
                    <Badge
                      color="error"
                      badgeContent={todoCount}
                      overlap="rectangular"
                    >
                      <Box component="span">To Do</Box>
                    </Badge>
                  ) : (
                    'To Do'
                  )
                }
              />
            </Tabs>
          </Box>

          {/* Tab Content */}
          {tabValue === 0 && (
            <Box component="form" autoComplete="off">
              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <ParentForm
                    title="Parent Profile"
                    disableInputs={true}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <ChildrenForm />
                </Grid>
              </Grid>
            </Box>
          )}

          {tabValue === 1 && (
            <ToDoTab
              onCountChange={(count) => {
                // When count is null, hide the badge (e.g., load error).
                // When count is 0, also hide the badge per requirements.
                if (count == null) {
                  setTodoCount(null);
                  return;
                }
                setTodoCount(count > 0 ? count : 0);
              }}
            />
          )}
        </Box>
      </Container>
    </div>
  );
};

export default ProfilePage;

